import { Typography } from 'antd';

const logoBlinketWhite = 'https://cdn.eduzzcdn.com/blinket/blinket-logo-white-v2.svg';
const logoBlinketDark = 'https://cdn.eduzzcdn.com/blinket/blinket-logo-dark-v2.svg';

const Maintenance = () => {
  return (
    <div className='flex min-h-screen w-full flex-col items-center justify-center gap-10 px-4'>
      <img className='h-12 w-auto dark:hidden' src={logoBlinketWhite} alt='Eduzz Eventos' />
      <img className='hidden h-12 w-auto dark:block' src={logoBlinketDark} alt='Eduzz Eventos' />
      <div className='flex flex-col items-center text-center'>
        <Typography.Title level={2} className='m-0'>
          OPS!
        </Typography.Title>
        <Typography.Text className='mt-3 block max-w-[520px] text-lg text-(--uizz-antd-color-text-secondary)'>
          Estamos em manutenção, tente voltar mais tarde.
        </Typography.Text>
      </div>
    </div>
  );
};
export default Maintenance;
